import React from 'react'
import { getMessage } from '../../../lib/translator'
import { getStatusColor, getStatusTint, stripStatusPrefix } from './statusColors'

/**
 * The fulfilment funnel, read left to right. Each tile's bar is scaled against the
 * largest status count rather than the grand total, so the smaller stages stay
 * legible instead of collapsing to a hairline.
 */
const OrderPipeline = ({ statuses, total, grandTotal, isLoading }) => {
  if (!statuses || !statuses.length) {
    return null
  }

  const counts = statuses.map((status) => Number((total || {})[status]) || 0)
  const peak = Math.max(...counts, 0)

  return (
    <section className="od-card od-pipeline" data-testid="dashboard-pipeline">
      <div className="od-pipeline-header">
        <h2 className="od-section-title">
          {getMessage('operations.dashboard.pipeline')}
        </h2>
        <span className="od-muted">
          {getMessage('operations.dashboard.pipeline.count', {
            count: grandTotal || 0,
          })}
        </span>
      </div>
      <div className="od-kpis">
        {statuses.map((status, index) => {
          const value = counts[index]
          const color = getStatusColor(status)
          const tint = getStatusTint(status)
          return (
            <div
              className="od-kpi"
              key={`pipeline-${status}`}
              data-testid={`pipeline-${status}`}
              style={{ background: tint.bg, borderColor: tint.border }}
            >
              <div className="od-kpi-label">
                <span className="od-dot" style={{ background: color }} />
                <span className="od-kpi-label-text">
                  {stripStatusPrefix(status)}
                </span>
              </div>
              {isLoading ? (
                <div className="od-skel od-kpi-skel" />
              ) : (
                <>
                  <div className="od-kpi-value" style={{ color }}>
                    {value}
                  </div>
                  <div className="od-kpi-track">
                    <div
                      className="od-kpi-bar"
                      style={{
                        width: peak ? `${(value / peak) * 100}%` : '0%',
                        background: color,
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default OrderPipeline
